import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'

class AdminStore {

    @observable users
    @observable user
    @observable informationrequests
    @observable golfclubrequests
    @observable applications
    @observable applicationwaitlist
    @observable application
    @observable contracts
    @observable contract
    @observable invoices
    @observable invoice
    @observable analytics
    @observable roles

    constructor() {
        this.informationrequests = null
        this.golfclubrequests = null
        this.applications = null
        this.applicationwaitlist = null
        this.application = null
        this.users = null
        this.user = null
        this.contracts = null
        this.contract = null
        this.invoices = null
        this.invoice = null
        this.analytics = {}
        this.roles = []
    }


    @computed get isUser() {
        return (this.user != null) ? true : false
    }

    @computed get isApplication() {
        return (this.application != null) ? true : false
    }

    @computed get isContract() {
        return (this.contract != null) ? true : false
    }

    @computed get isInvoice() {
        return (this.invoice != null) ? true : false
    }

    @computed get isUsers() {
        return this.users && this.users[0].objectId ? true : false
    }

    @action setUsers = (users) => {
        this.users = users
    }

    @action setUser = (user) => {
        this.user = user
    }

    @action onLogin = () => {
      this.loadAnalytics(new Date().getFullYear())
    }

    @action loadAnalytics = (year, cb) => {

      if(this.analytics[year]) return

      const from = new Date(year+"/1/1")
      const to = new Date().getFullYear() === year ? new Date() : new Date(year+"/12/31")

      let newAnalytics = { ...this.analytics }
      newAnalytics[year] = { loading: true }
      this.analytics = newAnalytics

      Parse.Cloud.run('getAnalytics', { from, to }).then(data => {

        let courseData = new Array()
        let courseMonthlyData = new Array()

        for(let course of data.clubs) {
          courseData.push({
            name: course.name,
            id: course.id,
            average: Number( (course.average * 30).toFixed(0) ),
            total: course.total,
            dailySlots: course.dailySlots,
            totalSlots: course.totalAvailable + ` (${course.availableDays} Tage)`,
            workload: Number( (course.workload).toFixed(0) ),
          })

          const monthly = {}

          course.monthly.forEach((item, i) => {
            monthly[i] = `${course.monthlyAverage[i].toFixed(1)}%`
          });


          courseMonthlyData.push({
            name: course.name,
            ...monthly
          })

        }

        let totalCompanyData = {
          name: "Gesamt",
          count: 0,
          total: 0,
          normal: 0,
          remaining: 0,
          totalAvailable: 0,
          totalRemainingAvailable: 0,
          remaining_coins: 0,
          used_coins: 0,
        }

        let companyData = new Array()
        let companyByCourseData = new Array()

        for(let company of data.companies) {
          companyData.push({
            name: company.name,
            used_coins: company.used_coins,
            remaining_coins: company.total_coins - company.used_coins,
            // average: (company.normal.average * 30).toFixed(0),
            // remaining_average: (company.remainingStock.average * 30).toFixed(0),
            total: company.normal.total + company.remainingStock.total,
            normal: company.normal.total,
            remaining: company.remainingStock.total,
            workload: (company.workload).toFixed(0) + `%`,
            // remaining_workload: (company.remainingStock.workload).toFixed(0) + `% (${company.remainingStock.total}/${Math.round(company.remainingStock.totalAvailable)})`,
            // rem_average: (company.remainingStock.average * 30).toFixed(2)
            // rem_total: company.remainingStock.total,
            // rem_workload: (company.remainingStock.workload).toFixed(2) + `% (${company.remainingStock.total}/${company.remainingStock.totalAvailable})`,
          })

          totalCompanyData.count++
          totalCompanyData.total += company.normal.total + company.remainingStock.total
          totalCompanyData.normal += company.normal.total
          totalCompanyData.remaining += company.remainingStock.total
          // totalCompanyData.workload += company.normal.workload
          // totalCompanyData.remaining_workload += company.remainingStock.workload
          totalCompanyData.totalAvailable += company.normal.totalAvailable
          totalCompanyData.totalRemainingAvailable += company.remainingStock.totalAvailable
          totalCompanyData.remaining_coins += company.total_coins - company.used_coins
          totalCompanyData.used_coins += company.used_coins


          companyByCourseData.push({
            name: company.name,
            ...company.golfCourseBookings
          })
        }

        totalCompanyData.workload = "-"

        newAnalytics = { ...this.analytics }
        newAnalytics[year] = {
          totalBookings: data.general.total,
          availableSlots: data.general.totalAvailable,
          average: (data.general.average * 30).toFixed(0),
          courseData,
          companyData,
          activeCompanies: data.general.activeCompanies,
          graveyard_bookings: data.general.graveyard_bookings,
          loading: false,
          totalCompanyData,
          companyByCourseData,
          courseMonthlyData,
          leads: data.leads,
        }

        this.analytics = newAnalytics

        cb && cb(this.analytics[year])
      })
    }

    @action sortUsers = () => {
        if (this.users) {
            this.users = _.orderBy(this.users, ['createdAt'], ['desc'])
        }/*
        if (this.allResidenceBookings) {
            this.allResidenceBookings = _.orderBy(this.allResidenceBookings, ['bookingStart.iso'], ['asc'])
        }*/
    }

    getUsers = async () => {

        let allUsers = []

        const config = await Parse.Config.get()
        let graveyard_user
        if(config.get("GRAVEYARD_COMPANY")) {
          const graveyard = await (new Parse.Query("Company")).equalTo("objectId", config.get("GRAVEYARD_COMPANY")).first()
          graveyard_user = graveyard && await (new Parse.Query("User")).equalTo("company", graveyard).first()
        }

        let applicationQuery = new Parse.Query("User")
        applicationQuery.include('company')
        applicationQuery.notEqualTo('objectId', graveyard_user && graveyard_user.id)
        applicationQuery.each((app, key) => {
            allUsers.push(app.toJSON())
        }).then(res => {
            this.setUsers(allUsers)
            if (allUsers.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
                this.setUsers(allUsers)
                this.sortUsers()
            }
        }).catch(err => {
            console.error("error active bookings", err)
        })

    }

    getUserByID = (uid) => {
        this.setUser(null)

        if (uid === "new") {
          this.setUser({
    				firstname: "",
    				objectId: "",
    				title: "",
    				genderTitle: "",
    				lastname: "",
    				position: "",
    				gender: "",
    				clothingSize: "",
    				profileImage: "",
    				phone: "",
    				username: "",
    				email: "",
            homeGolfCourse: "",
            handicap: 0,
            company: {},
            companyId: "",
    				birthday: ""
          })
          return
        }

        let userQuery = new Parse.Query("User")
        userQuery.include('company')

        userQuery.equalTo("objectId", uid)
        userQuery.first().then(result => {
            let user = result.toJSON()

            // The email is not returned by the parse backend. So it is set here since username and email are identical.
            // In the backend the username is made the same as the email in the updateUserById Cloud function.
            user.email = user.username
            delete user.readNews

            if (!user.company)
                user.company = {}

            this.setUser(user)

            return Parse.Cloud.run('getUserRole', {
                currentUserId: uid,
            })
        }).then(role => {
            this.setUser({ ...this.user, role: role.name || null })
            // user.role = role.name

        }).catch(error => {
            console.error("error", error)
        })
    }

    getContractByID = (id) => {
        this.setContracts(null)
        this.setInvoices(null)

        let contractQuery = new Parse.Query("Contract")
        contractQuery.include('company.region.country')

        let invoiceQuery = new Parse.Query("Invoice")

        let invoiceTemp = []

        contractQuery.equalTo("objectId", id)
        contractQuery.first().then(result => {
          const contract = result.toJSON()
          this.setContract(contract)

          invoiceQuery.equalTo("contract", result)
          return invoiceQuery.each(invoice => {
            invoiceTemp.push(invoice.toJSON())
          })
        }).then(res => {
          this.setInvoices(invoiceTemp)
        }).catch(error => {
            console.error("error", error)
        })
    }

    getInvoiceByID = (id) => {
        this.setInvoices(null)

        let invoiceQuery = new Parse.Query("Invoice")
        invoiceQuery.include('contract.company.region.country')

        invoiceQuery.equalTo("objectId", id)
        invoiceQuery.first().then(result => {
            const invoice = result.toJSON()
            this.setInvoice(invoice)
        }).catch(error => {
            console.error("error", error)
        })
    }

    getApplicationById = (id) => {
        this.setInvoices(null)

        let applicationQuery = new Parse.Query("Application")

        applicationQuery.equalTo("objectId", id)
        applicationQuery.include("region.country.*")
        applicationQuery.first().then(result => {
            const application = result.toJSON()
            console.log(application.region);
            this.setApplication( application )
        }).catch(error => {
            console.error("error", error)
        })
    }

    @computed get isApplications() {
        return this.applications && this.applications[0].objectId ? true : false
    }

    @action setApplications = (applications) => {
        this.applications = applications
    }

    @action setApplicationWaitlist = (applications) => {
        this.applicationwaitlist = applications
    }

    @action setApplication = (application) => {
        this.application = application
    }

    @action sortApplications = () => {
        if (this.applications) {
            this.applications = _.orderBy(this.applications, ['createdAt'], ['desc'])
        }/*
        if (this.allResidenceBookings) {
            this.allResidenceBookings = _.orderBy(this.allResidenceBookings, ['bookingStart.iso'], ['asc'])
        }*/
    }

    getApplications = () => {

        let allApplications = []

        let applicationQuery = new Parse.Query("Application")

        applicationQuery.each((app, key) => {
            allApplications.push(app.toJSON())
        }).then(res => {
            this.setApplications(allApplications)
            if (allApplications.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
                this.setApplications(allApplications)
                this.sortApplications()
            }
        }).catch(err => {
            console.error("error active bookings", err)
        })

    }

    getApplicationWaitlist = () => {

        let allApplications = []

        let applicationQuery = new Parse.Query("ApplicationWaitlist")
        applicationQuery.include("region").notEqualTo("contacted", true)

        applicationQuery.each((app, key) => {
            allApplications.push(app.toJSON())
        }).then(res => {
            this.setApplicationWaitlist(allApplications)
            if (allApplications.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
                this.setApplicationWaitlist(allApplications)
            }
        }).catch(err => {
            console.error("error active bookings", err)
        })

    }

    @computed get isInformationrequests() {
        return this.informationrequests && this.informationrequests[0].objectId ? true : false
    }

    @action setInformationrequests = (informationrequests) => {
        this.informationrequests = informationrequests
    }

    @action sortInformationrequests = () => {
        if (this.informationrequests) {
            this.informationrequests = _.orderBy(this.informationrequests, ['createdAt'], ['desc'])
        }/*
        if (this.allResidenceBookings) {
            this.allResidenceBookings = _.orderBy(this.allResidenceBookings, ['bookingStart.iso'], ['asc'])
        }*/
    }

    getInformationrequests = () => {

        let allRequests = []

        let applicationQuery = new Parse.Query("InformationRequest")

        applicationQuery.each((app, key) => {
            allRequests.push(app.toJSON())
        }).then(res => {
            this.setInformationrequests(allRequests)
            if (allRequests.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
                this.setInformationrequests(allRequests)
                this.sortInformationrequests()
            }
        }).catch(err => {
            console.error("error active bookings", err)
        })

    }

    @computed get isGolfclubrequests() {
        return this.golfclubrequests && this.golfclubrequests[0].objectId ? true : false
    }

    @action setGolfclubrequests = (golfclubrequests) => {
        this.golfclubrequests = golfclubrequests
    }

    getGolfclubrequests = () => {

        let allRequests = []

        let applicationQuery = new Parse.Query("GolfCourseRequest")

        applicationQuery.include('region');
        applicationQuery.each((app, key) => {
            allRequests.push(app.toJSON())
        }).then(res => {
            this.setGolfclubrequests(allRequests)
            if (allRequests.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
              this.setGolfclubrequests(allRequests)
            }
        }).catch(err => {
            console.error("error golfclub requests", err)
        })

    }

    @computed get isContracts() {
        return this.contracts && this.contracts[0].objectId ? true : false
    }

    @action setContracts = (contracts) => {
        this.contracts = contracts
    }

    @action setContract = (contract) => {
        this.contract = contract
    }

    getContracts = () => {

        let allContracts = []

        let contractQuery = new Parse.Query("Contract")
        contractQuery.include('company')

        contractQuery.each((app, key) => {
            allContracts.push(app.toJSON())
        }).then(res => {
            this.setContracts(allContracts)
        }).catch(err => {
            console.error("error adminStore.getContracts", err)
        })
    }

    @computed get isInvoices() {
        return this.invoices && this.invoices[0].objectId ? true : false
    }

    @action setInvoices = (invoices) => {
        this.invoices = invoices
    }

    @action setInvoice = (invoice) => {
        this.invoice = invoice
    }

    unsetInvoice = () => {
        this.invoice = null
    }

    getInvoices = () => {

        // if(this.invoices && this.invoices.length > 0) return

        let allInvoices = []

        let invoiceQuery = new Parse.Query("Invoice")
        invoiceQuery.include('contract')
        invoiceQuery.include('contract.company')
        invoiceQuery.greaterThan('createdAt', new Date((new Date()).getFullYear() - 1 + '/1/1') ) // remove if we want to see all invoices not only the last year

        invoiceQuery.each((app, key) => {
            allInvoices.push(app.toJSON())
        }).then(res => {
            this.setInvoices(allInvoices)
        }).catch(err => {
            console.error("error adminStore.getInvoices", err)
        })
    }

    sendContractReminderMail = (id) => {
        Parse.Cloud.run('sendContractReminderMail', { contractId: id }).then(result => {
        }).catch(error => {
            console.error("error acceptContract", error)
        })
    }

    sendInvoiceReminderMail = (id) => {
        Parse.Cloud.run('sendInvoiceReminderMail', { invoiceId: id }).then(result => {

        }).catch(error => {
            console.error("error acceptContract", error)
        })
    }

    @computed get isRoles() {
        return this.roles && this.roles.length > 0
    }

    @action setRoles = (roles) => {
        this.roles = roles
    }

    getRoles = async () => {
        if(this.isRoles) return

        const roles = await new Parse.Query("_Role").equalTo("isMembershipType", true).find()
        this.setRoles(roles.map(item => item.toJSON()))
    }
}

const store = new AdminStore()
export default store



// WEBPACK FOOTER //
// /src/stores/AdminStore.js